import * as React from 'react';
import { Button } from '@helpcenter/analytics-components';
import { useIntl } from 'react-intl-next';
import ArrowLeftCircleIcon from '@atlaskit/icon/glyph/arrow-left-circle';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import messages from './messages';

interface BackButtonProps {
    text?: string;
    actionSubjectId: string;
    onClick: () => void;
}

const BackButton = (props: BackButtonProps) => {
    const { formatMessage } = useIntl();
    const { onClick, actionSubjectId, text } = props;
    const backButtonText = text ? text : formatMessage(messages.backButtonText);

    return (
        <Button
            appearance="subtle"
            actionSubjectId={actionSubjectId}
            onClick={onClick}
            aria-label={backButtonText}
            iconBefore={<ArrowLeftCircleIcon label="" size="small" primaryColor={token('color.icon', colors.N500)} />}
            data-test-id="back-button"
        >
            {backButtonText}
        </Button>
    );
};

export default BackButton;
